import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { deleteEmptyData } from 'src/app/config/app-utils';
import { NavbarService } from '../../services/navbar.service';
import { SessionService } from '../../services/session.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-session',
  templateUrl: './session.component.html'
})
export class SessionComponent implements OnInit {

  dataForm: FormGroup;

  cambiarClave: boolean = false;

  constructor(private fb: FormBuilder, private toastr: ToastrService, private service: SessionService,
    private navbarService: NavbarService, private router: Router) {

  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.dataForm = this.fb.group({
      codigoUsuario: ['', [Validators.required]],
      password: ['', Validators.required]
    })
  }

  login() {
    let data = deleteEmptyData(this.dataForm.value);

    this.service.login(data).subscribe(
      (resp: any) => {
        this.toastr.success('Sessión iniciada', 'Éxito');
        this.navbarService.mostrar = false;
        this.navbarService.usuario = resp.usuario;
        localStorage.setItem('session', JSON.stringify(resp));
        this.dataForm.reset();
        this.router.navigate([''], { queryParams: { 'hb': '1' } });
      }, err => {
        this.toastr.warning("Usuario o contraseña no válidos", 'Atención');
        this.cambiarClave = true;
      }
    );
  }

}
